/**
 * UI8 Hire button (UI8-16)
 *
 * Decides where a "Hire" click lands BEFORE any form is shown: signed-out
 * users go to login, users who can still send an inquiry get the brief
 * composer, and users who are out of inquiries get the paywall straight
 * away. Filling in a whole brief only to be told it can't be sent is the
 * wrong order.
 */
angular.module("UI8.directives").directive("ui8HireButton", [
  function () {
    return {
      restrict: "A",
      link: function (scope, element) {
        element.on("click", function (event) {
          event.preventDefault();

          var config = window.UI8 || {};

          if (!config.loggedIn) {
            window.location =
              "/account/login?from=" +
              encodeURIComponent(window.location.pathname);
            return;
          }

          $("body").addClass(
            config.hireCanInquire ? "hire-modal" : "hire-paywall-modal"
          );
        });
      },
    };
  },
]);
